import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Kanban from './pages/Kanban';
import Agents from './pages/Agents';
import Chat from './pages/Chat';
import Settings from './pages/Settings';
import Budget from './pages/Budget';
import Connections from './pages/Connections';
import InferenceMonitor from './pages/InferenceMonitor';
import './styles/globals.css';

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <Router>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#1e1e2e',
                color: '#f1f5f9',
                border: '1px solid #2d2d3d'
              }
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="kanban" element={<Kanban />} />
              <Route path="agents" element={<Agents />} />
              <Route path="chat" element={<Chat />} />
              <Route path="budget" element={<Budget />} />
              <Route path="connections" element={<Connections />} />
              <Route path="inference" element={<InferenceMonitor />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
